import { render, staticRenderFns } from "./PlanDetailCard.vue?vue&type=template&id=60af7045&scoped=true"
import script from "./PlanDetailCard.vue?vue&type=script&lang=js"
export * from "./PlanDetailCard.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailCard.vue?vue&type=style&index=0&id=60af7045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af7045",
  null
  
)

export default component.exports